import React from 'react';
import { Bar, BarChart, Tooltip, XAxis, YAxis } from 'recharts';
import useReviews from '../hooks/useReviews';

const Barchart = () => {
    const [data, setData] = useReviews();
    return (
        <BarChart width={500} height={410} data={data}>
        <XAxis dataKey="month" />
          <YAxis/>
          <Tooltip/>
        <Bar dataKey="sell" fill="#8884d8" />
      </BarChart>
    );
};

export default Barchart;